import { Intent } from '@blueprintjs/core';
import * as React from 'react';

import { InvalidMappingsWarning } from 'src/components/InvalidMappingsWarning';
import { withConfirmation } from 'src/components/withConfirmation';
import { Mapping } from 'src/containers/ProjectDiagram/types/data';
import {
  ProjectFileUpload,
  ProjectVirtualGraph,
} from 'src/store/state/projects';
import * as copy from 'src/templates/copy';

export const confirmAcceptInvalidMappings = async ({
  fileUploadsById,
  virtualGraphsById,
  invalidMappingsByResource,
}: {
  fileUploadsById: Record<string, ProjectFileUpload>;
  virtualGraphsById: Record<string, ProjectVirtualGraph>;
  invalidMappingsByResource: Record<string, Mapping[]>;
}) => {
  return new Promise<boolean>((resolve) => {
    const hasInvalidMappings = Object.values(invalidMappingsByResource).some(
      (mappings) => mappings.length
    );
    if (!hasInvalidMappings) {
      resolve(true);
      return;
    }

    withConfirmation({
      dialogClassName: 'sd-dialog-invalid-mappings',
      message: (
        <InvalidMappingsWarning
          fileUploadsById={fileUploadsById}
          mappingsByResource={invalidMappingsByResource}
          virtualGraphsById={virtualGraphsById}
        />
      ),
      noButtonIntent: Intent.PRIMARY,
      noButtonOutlined: true,
      noPrompt: copy.components.invalidMappings.dialog.cancel,
      title: copy.components.invalidMappings.dialog.title,
      yesButtonIntent: Intent.PRIMARY,
      yesPrompt: copy.components.invalidMappings.dialog.proceed,
      onConfirmationSuccess: () => resolve(true),
      onConfirmationFailure: () => resolve(false),
    });
  });
};
